import { Pipe, PipeTransform } from '@angular/core';

import { STOP_TITLES } from '@app/modules/flight-results/constants/filters.constants';

@Pipe({
  name: 'stopName',
  standalone: false
})
export class StopNamePipe implements PipeTransform {

  constructor() { }

  transform(code: string, ...args: string[]): string {
    return STOP_TITLES[code];
  }
}
